import {Component}                          from '@angular/core';
import {Timestamp}                          from '@angular/fire/firestore';
import {VapeDryConfIntf, VapeRecordLogIntf} from '@djsharkk/logr-types';
import {MenuCrudPanelContentBase}           from '../../menu-crud-panel-content-base';
import {MenuCrudPanelTopComponent}          from '../menu-crud-panel-top.component';

@Component({
			   selector   : 'app-menu-crud-panel-vape-top',
			   imports    : [
				   MenuCrudPanelTopComponent
			   ],
			   templateUrl: './menu-crud-panel-vape-top.component.html',
			   styleUrl   : './menu-crud-panel-vape-top.component.css'
		   })
export class MenuCrudPanelVapeTopComponent extends MenuCrudPanelContentBase<VapeRecordLogIntf, VapeDryConfIntf> {

	constructor() {
		super('vape', false);

		this.svcDataFactory.svcDataVape.vapeConf.subscribe(confs => {
			this.recordRowsConf = confs;
			this.recordConfBtns = confs.sort((a, b) => a.data.strength > b.data.strength ? 1 : -1).map((c, i) => {
				const d = {
					uuid: c.id as string,
					icon: i.toString().padStart(2, `0`),
					text: [
						c.label,
						`${c.data.strength * 100}% ${c.data.type}`
					],
					func: () => this.addRecord(c)
				}

				if (c.data.ratio) {
					d.text[1] = `${c.data.strength * 100}% ${c.data.ratio['indica']}:${c.data.ratio['sativa']}`;
				}

				return d
			}).sort((a, b) => b.icon.localeCompare(a.icon))


		})

	}

	public addRecord(conf: VapeDryConfIntf) {
		this.svcDataFactory.svcDataVape.createRecord({
														 ...conf.data,
														 timestamp: Timestamp.now()
													 })
	}


}
